<template>
    <div>
        <b-container v-if="!isJACareerEntrepreApp" class="home-page">
            <b-row>
                <b-col cols="12">
                    <div class="wrapper-projects">
                        <b-button tabindex="0" block variant="primary" @click="createProject()">Start New Project</b-button>
                        <h3 tabindex="0">
                            My Projects
                        </h3>
                        <project-delete-modal
                                ref="project_delete_modal"
                                :projectIndex="projectIndexSelected"
                                :projectId="projectIdSelected"
                                v-on:close-delete-modal="closeDeleteProjectModal()"/>
                        <project-actions-modal
                                ref="project_actions_modal"
                                :projectIndex="projectIndexSelected"
                                :projectId="projectIdSelected"
                                v-on:open-delete-modal="openDeleteProjectModal()"/>
                        <div class="project-status">
                            <div class="project-status-item" :key="index" v-for="(p, index) in projects">
                                <project-status :index="index" :project="p" tabindex="0" role="button"
                                                :show-actions="true" :show-action-sync="!p.sync"
                                                @onSync="onSyncProject"
                                                @onDelete="openModalActions"
                                                @click="openProject(index, p.lastStep, p.type)"/>
                            </div>
                        </div>
                    </div>
                </b-col>
                <b-col cols="12">
                    <div class="wrapper-quick-links">
                        <h3 tabindex="0">
                            Quick links
                        </h3>
                        <ul>
                            <li>
                                <a @click="openStyleGuide(styleGuides.CUSTOMER_DRIVE_INNOVATION_GUIDE)" href="javascript:void(0)">
                                    Customer Driven Innovation(CDI) Guide</a>
                            </li>
                            <li>
                                <a @click="openStyleGuide(styleGuides.DEEP_CUSTOMER_EMPATHY_GUIDE)" href="javascript:void(0)">
                                    Deep Customer Empathy Guide</a>
                            </li>
                            <li>
                                <a @click="openStyleGuide(styleGuides.FOLLOW_ME_HOME_GUIDE)" href="javascript:void(0)">
                                    Follow Me Home Guide</a>
                            </li>
                            <li>
                                <a href="javascript:void(0)" @click="openStyleGuide(styleGuides.CUSTOMER_INTERVIEW_GUIDE)">
                                    Customer Interview guide
                                </a>
                            </li>
                            <li>
                            <a @click="openStyleGuide(styleGuides.INTERVIEW_QUESTION_GUIDE)" href="javascript:void(0)">
                                    Interview Question Guide
                                </a>
                            </li>

                            <li>
                                <a @click="openStyleGuide(styleGuides.CUSTOMER_PROBLEM_STATEMENT_GUIDE)" href="javascript:void(0)">
                                    Customer Problem Statement Guide
                                </a>
                            </li>
                            <li>
                                <a @click="openStyleGuide(styleGuides.IDEAL_STATE)" href="javascript:void(0)">
                                    Ideal State Guide
                                </a>
                            </li>
                            <li>
                                <a @click="openStyleGuide(styleGuides.GO_BROAD_TO_GO_NARROW)" href="javascript:void(0)">
                                    Go Broad to Go Narrow Guide
                                </a>
                            </li>
                            <li>
                                <a @click="openStyleGuide(styleGuides.BRAINSTORMING)" href="javascript:void(0)">
                                    Brainstorming Guide
                                </a>
                            </li>
                            <li>
                                <a @click="openStyleGuide(styleGuides.POINTS_NARROWING)" href="javascript:void(0)">
                                    100 Points Guide
                                </a>
                            </li>
                            <li>
                                <a @click="openStyleGuide(styleGuides.NARROWING)" href="javascript:void(0)">
                                    2-by-2 Guide
                                </a>
                            </li>
                            <li>
                                <a @click="openStyleGuide(styleGuides.SKETCH_PROTOTYPE)" href="javascript:void(0)">
                                    Sketch Prototype Guide
                                </a>
                            </li>
                            <li>
                                <a @click="openStyleGuide(styleGuides.RAPID_EXPERIMENTS)" href="javascript:void(0)">
                                Rapid Experiments with Customers Guide
                                </a>
                            </li>
                            <li>
                                <a @click="openStyleGuide(styleGuides.LEAP_FAITH_ASSUMPTIONS)" href="javascript:void(0)">
                                Leap of Faith Assumptions Guide
                                </a>
                            </li>
                            <li>
                                <a @click="openStyleGuide(styleGuides.TYPES_EXPERIMENTS)" href="javascript:void(0)">
                                Experiments Guide
                                </a>
                            </li>
                            <li>
                                <a @click="openStyleGuide(styleGuides.TEST_HYPOTHESIS_TEST_PLAN)" href="javascript:void(0)">
                                Hypothesis Guide
                                </a>
                            </li>
                            <li v-if="isJAApp" >
                                <a :href="getMessage(17, 'rapidexperiment-link', 2)" target="_blank" >
                                {{getMessage(17, 'rapidexperiment-link-text', 2)}} PDF
                                </a>
                            </li>
                            <li v-if="isJAApp" >
                                <a :href="getMessage(19, 'rapidexperiment-link', 2)" target="_blank" >
                                {{getMessage(19, 'rapidexperiment-link-text', 2)}} PDF
                                </a>
                            </li>
                            <li v-if="isJAApp">
                                <a :href="getMessage(20, 'rapidexperiment-link', 2)" target="_blank" >
                                {{getMessage(20, 'rapidexperiment-link-text', 2)}} PDF
                                </a>
                            </li>
                            <li v-if="isJAApp">
                                <a :href="getMessage(21, 'rapidexperiment-link', 2)" target="_blank" >
                                {{getMessage(21, 'rapidexperiment-link-text', 2)}} PDF
                                </a>
                            </li>
                            <li v-if="isJAApp">
                                <a :href="getMessage(3, 'empathy-map-link', 2)" target="_blank" >
                                {{getMessage(3, 'empathy-map-link-text', 2)}} PDF
                                </a>
                            </li>
                        </ul>
                    </div>
                </b-col>
            </b-row>
            <project-selection></project-selection>
            <project-style-guide :style-guide="styleGuide"/>
        </b-container>
        <div v-else class="new-home">
            <div class="home">
                <b-container class="home-container">
                    <p v-if="isJACareerApp" class="home-container__text-first">
                        How do you design your best possible future career? Approach your career
                        exploration like an entrepreneur by using the Design for Delight method.<br>
                        This activity is designed to be completed over multiple sessions.
                    </p>
                    <p v-if="isJAEntrepreApp" class="home-container__text-first">
                        How do you design the best possible new product or service? Develop your
                        new idea like an entrepreneur by using the Design for Delight method.<br>
                        This activity is designed to be completed over multiple sessions and will result
                        in the foundation for a successful product or service launch.
                    </p>
                    <p class="home-container__text-second">
                        Select the Install icon in your browser window to install the JA Future by Design app.
                    </p>
                    <div class="home-container-buttons">
                        <b-button v-if="isJACareerApp" class="btn-start" tabindex="0" block variant="primary" :to="{ name: 'Activities' }">Create My Career Plan</b-button>
                        <b-button v-if="isJAEntrepreApp" class="btn-start" tabindex="0" block variant="primary" :to="{ name: 'Activities' }">Create My Project</b-button>
                        <b-button class="btn-cancel" tabindex="0" block variant="outline-primary" @click="logout">Cancel</b-button>
                    </div>
                </b-container>
            </div>
        </div>
    </div>
</template>

<script>
    import {ProjectService} from '../../../core/Services'
    import ProjectStatus from "../../../core/Components/ProjectStatus"
    import ProjectActionsModal from "../../../core/Components/ProjectActionsModal"
    import ProjectDeleteModal from "../../../core/Components/ProjectDeleteModal"
    import ProjectSelection from "../Components/ProjectSelection"
    import {Storage, Project, ConflictSyn, Zoom} from '../../../core/Utils'
    import ModalConflictSync from "../../../core/Components/ModalConflictSync";
    import StyleGuides from '../../../core/Utils/style-guides';
    import ProjectStyleGuide from "../../../core/Components/ProjectStyleGuide";
    import {AuthService} from '../../Security/Services'


    export default {
        name: "Home",
        data() {
            return {
                projects: [],
                projectIndexSelected: null,
                projectIdSelected: null,
                styleGuides: StyleGuides,
                styleGuide: {}
            }
        },
        components: {
            ModalConflictSync,
            ProjectStatus,
            ProjectSelection,
            ProjectActionsModal,
            ProjectDeleteModal,
            ProjectStyleGuide,
        },
        mounted() {
            this.projects = Storage.getProjects()
            const user = Storage.getUser()

            if (user.id && this.isOnline) {
                ProjectService.getAllProjects(user.id).then(response => {
                    Storage.setAllProjects(response.projects)
                    this.projects = Storage.getProjects()
                }).catch(err => {
                    // TODO: handle error
                })

                ProjectService.getProjectMessages(user.id).then(response => {
                    Storage.setProjectMessages(response.messages);
                }).catch(err => {
                    // TODO: handle error
                })
            }
        },
        created: function () {
            this.$eventHub.$on('discard-project', (p) => {
                this.projects = Storage.getProjects()
            });

            this.$eventHub.$on('keep-version-project', (p) => {
                this.projects = Storage.getProjects()
            });
        },
        methods: {
            openProject(index, lastStep, type) {
                const projectUrl = Project.getProjectURL(index, type, lastStep)
                this.$router.push({...projectUrl})
            },
            createProject() {
                if (this.isJAApp) {
                    this.$bvModal.show('new-project')
                } else {
                    this.$router.push({name: "start_project"})
                }
            },
            onSyncProject(project, index) {
                Project.syncProject(project, index, this.isOffline, true).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.projects = Storage.getProjects()
                    }
                })
            },
            openModalActions(project, index) {
                this.projectIndexSelected = index;
                this.projectIdSelected = project.projectId;
                this.$refs.project_actions_modal.$refs["modal"].show()
            },
            openDeleteProjectModal() {
                this.$refs.project_delete_modal.$refs["modal"].show()
            },
            closeDeleteProjectModal() {
                this.projects = Storage.getProjects()
                this.$refs.project_actions_modal.$refs["modal"].hide()
            },
            openStyleGuide(currentStyleGuide) {
                if(currentStyleGuide){
                    this.styleGuide = this.styleGuides.getStyleGuide(currentStyleGuide);
                    this.$bvModal.show('project-style-guide')
                }
            },
            logout() {
                const user = Storage.getUser()
                AuthService.logout()
                Zoom.setAppZoom(100)
                if(this.isJACareerEntrepreApp) {
                    this.$router.push({name: 'Login'})
                } else if (user.isExternalLogin) {
                    this.$router.push({name: 'SSOLogout'})
                } else {
                    this.$router.push({name: 'Login'})
                }
            },
        }
    }
</script>

<style scoped lang="stylus">
    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"

    .navbar-item-left
        display block

    .home-page
        margin-top 90px

    .wrapper-quick-links
        padding 25px 20px

        h3
            font font-sourcesans-semibold
            font-size 16px
            color color-black

        ul
            padding-left 20px
            margin 0
            color color-5

            li
                margin-bottom 15px
                font-size 16px

            a
                color inherit
                text-decoration underline

    .wrapper-projects
        border-radius 27px
        box-shadow(0px 4px 5px 0px #BDD5E580)
        background-color white
        padding 25px 20px

        h3
            font font-poppins-semibold
            font-size 18px
            margin-top 20px

    .new-home
        background-color color-1

        .home
            padding-bottom 3rem
            padding-top 20px

            &-container
                color color-dark
                box-shadow(0px 1px 5px color-shadow)
                padding 25px 20px 30px 25px
                border-radius 25px
                background-color color-blank
                margin-top 0px
                width 90%
                max-width none !important

                &__text-first
                    font font-poppins-semibold
                    font-size 16px
                    margin-bottom 75px

                &__text-second
                    font font-sourcesans-regular
                    font-size 13px
                    margin-bottom 39px

                &-buttons
                    display flex
                    flex-direction column

                    .btn
                        width 100%
                        height 40px
                        margin-right auto
                        margin-left auto
                        min-height revert !important

                    .btn-start
                        background-color color-green-light
                        &:hover
                            background-color color-green-dark

                    .btn-cancel
                        margin-top 31px
                        color color-green-light
                        font font-poppins-semibold
                        font-size 16px

    @media (min-width: 768px) and (max-width: 1200px)
        .home
            padding-top 30px !important

            &-container
                &__text-first
                    font-size 18px !important

                &__text-second
                    font-size 16px !important

                .btn
                    width 320px !important

    @media (min-width: 1200px)
        .new-home
            background-color color-blank

            .home
                padding-top 36px !important

                &-container
                    padding 50px 50px 51px 50px !important
                    width 65%

                    &__text-first
                        font-size 22px !important

                    &__text-second
                        font-size 18px !important

                    .btn
                        width 320px !important
                        height 50px !important

</style>
